import "scripts/templates/page.press-postpartum-1.js";
import { registerBundle } from "scripts/lib/register-bundle.js";
registerBundle("template.page.press-postpartum-1");
